import { EffectCallback, useEffect } from 'react';

const useOnlyOnce = (effect: EffectCallback) => {
  return useEffect(effect, []);
};

export default useOnlyOnce;
